var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[(!_vm.isReportGenerated)?_c('WidgetReport',{attrs:{"caseStatus":_vm.caseStatus}}):_c('Report',{attrs:{"isEditable":_vm.isEditable}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }